'use strict';

export const donationAmountElements = () => ({
    donationAmountSelect: document.querySelectorAll('input[name=donationAmountSelect]'),
    donationAmountOther: document.querySelector('div.other-donation')
});
